module.exports = __webpack_public_path__ + "static/media/YM84_1.c49c6bf5.jpg";